import { Workbook } from "exceljs";
import { EnrollmentSummaryResponse } from "../../services/reports.service";
import {
	applyHeaderStyle,
	rateFillArgb,
	statusFillArgb,
} from "./workbook-styles";

export const addEnrollmentSummarySheet = (
	workbook: Workbook,
	data: EnrollmentSummaryResponse,
): void => {
	const sheet = workbook.addWorksheet("Enrollments");
	sheet.columns = [
		{ header: "Participant", key: "participantName", width: 28 },
		{ header: "Org unit", key: "orgUnit", width: 22 },
		{ header: "Researcher", key: "researcher", width: 22 },
		{ header: "Start date", key: "startDate", width: 14 },
		{ header: "Day", key: "day", width: 8 },
		{ header: "Total days", key: "totalDays", width: 12 },
		{ header: "Status", key: "status", width: 14 },
		{ header: "Completion %", key: "completionPct", width: 14 },
	];
	applyHeaderStyle(sheet.getRow(1));

	for (const row of data.enrollments) {
		const r = sheet.addRow({
			participantName: row.participantName,
			orgUnit: row.orgUnit,
			researcher: row.researcher,
			startDate: row.startDate?.slice(0, 10) ?? "",
			day: row.day,
			totalDays: row.totalDays,
			status: row.status,
			completionPct: row.completionPct,
		});

		const statusFill = statusFillArgb(row.status);
		if (statusFill) {
			r.getCell("status").fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: statusFill },
			};
		}
		const rateFill = rateFillArgb(row.completionPct);
		if (rateFill) {
			r.getCell("completionPct").fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: rateFill },
			};
		}
		r.getCell("completionPct").numFmt = "0.0";
	}
};
